<template>
  <div>
    <v-card
      :to="to"
      class="item"
      v-for="(
        { img_cover_desktop, img_cover_mobile, title, subtitle, to }, i
      ) in items"
      tile
      :key="i"
    >
      <img
        loading="lazy"
        :src="
          files +
          (w <= 600 && img_cover_mobile
            ? img_cover_mobile
            : img_cover_desktop) +
          `?resize=1&w=${w}`
        "
        :class="
          'video-img primary lighten-2' + (i + 1 < items.length ? ' mb-2' : '')
        "
        :alt="title"
      />

      <div class="caption">
        <div>
          <div class="play-icon d-flex align-end justify-center mb-8">
            <v-icon> fa fa-play </v-icon>
          </div>

          <div
            class="caption-title text-uppercase white--text font-weight-black text-center"
            v-if="title"
          >
            {{ title }}
          </div>

          <div
            class="caption-category white--text font-weight-regular text-center mt-2"
            v-if="subtitle"
          >
            {{ subtitle }}
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    w() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 600;
        case "sm":
          return 960;
        case "md":
          return 1264;
        case "lg":
          return 1440;
        default:
          return 1920;
      }
    },
  },
};
</script>

<style scoped>
.videos .item {
  position: relative;
}

.video-img {
  display: block;
  object-fit: cover;
  -o-object-fit: cover;
  object-position: center;
  -o-object-position: center;
  width: 100%;
}

@media screen and (min-width: 600.001px) {
  .video-img {
    height: 40vh;
    min-height: 500px;
  }
}

@media screen and (max-width: 600px) {
  .video-img {
    aspect-ratio: 1 / 1;
  }
}

.caption {
  align-items: center;
  background: rgb(0, 0, 0);
  background: -moz-linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0.12) 100%
  );
  background: -webkit-linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0.12) 100%
  );
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0.12) 100%
  );
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.play-icon {
  height: 100px;
}

.caption .v-icon {
  background-clip: text;
  -o-background-clip: text;
  -moz-background-clip: text;
  -webkit-background-clip: text;
  background-color: #ffffff;
  font-size: 60px;
  text-fill-color: transparent;
  -o-text-fill-color: transparent;
  -moz-text-fill-color: transparent;
  -webkit-text-fill-color: transparent;
  transition: all 0.2s linear;
}

.item:hover .v-icon {
  background: rgb(237, 50, 55);
  background: -moz-linear-gradient(
    0deg,
    rgba(243, 116, 53, 1) 0%,
    rgba(237, 50, 55, 1) 100%
  );
  background: -webkit-linear-gradient(
    0deg,
    rgba(243, 116, 53, 1) 0%,
    rgba(237, 50, 55, 1) 100%
  );
  background: linear-gradient(
    0deg,
    rgba(243, 116, 53, 1) 0%,
    rgba(237, 50, 55, 1) 100%
  );
  background-clip: text;
  -o-background-clip: text;
  -moz-background-clip: text;
  -webkit-background-clip: text;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#f37435",endColorstr="#ed3237",GradientType=1);
  font-size: 100px;
  text-fill-color: transparent;
  -o-text-fill-color: transparent;
  -moz-text-fill-color: transparent;
  -webkit-text-fill-color: transparent;
  transform: rotate(-90deg);
}

.caption-title {
  font-size: 37px;
  line-height: 44px;
  letter-spacing: 0.25rem;
}

.caption-category {
  font-size: 21px;
}

@media screen and (max-width: 600px) {
  .play-icon {
    height: 60px;
  }

  .caption .v-icon {
    font-size: 44px;
  }

  .item:hover .v-icon {
    font-size: 60px;
  }

  .caption-title {
    font-size: 22px;
    line-height: 26px;
  }

  .caption-category {
    font-size: 18px;
  }
}
</style>
